module.exports = __webpack_public_path__ + "img/pc_01.8caacbe4.png";